import axios from "axios"

//import type { IApi } from "~/shared/api/IApi"
import { apiUrlPrefix } from "~/shared/config"

/**
 * Настроенный экземпляр {@link https://axios-http.com/ru/docs/intro axios} для отправки запросов к http-сервисам.
 * @example
 * ```tsx
 * import {api} from "~/shared/api";
 *
 * api.get("относительный/путь/к/api")
 *  .then(result => console.log(result.data))
 *  .catch(error => console.error(error.response.data));
 * ```
 *
 * @example
 * ```tsx
 * import {api} from "~/shared/api";
 *
 * api("относительный/путь/к/api", { method: "get" })
 *  .then(result => console.log(result.data))
 *  .catch(error => console.error(error.response.data));
 * ```
 */
export const api = axios.create({
	baseURL: apiUrlPrefix,
	withCredentials: true,
})
